export default {"src":"/hedera/_next/static/media/tick.71d0d196.svg","height":16,"width":16};